import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { useAuth } from "@/contexts/AuthContext";
import { useApp } from "@/contexts/AppContext";

export default function AppShell() {
  const { user } = useAuth();
  const { cases, loadCases } = useApp();
  const navigate = useNavigate();
  const [bootstrapped, setBootstrapped] = useState(false);

  useEffect(() => {
    if (user === false) navigate("/login", { replace: true });
  }, [user, navigate]);

  useEffect(() => {
    (async () => {
      if (user && typeof user === "object") {
        const c = await loadCases();
        if (!c || c.length === 0) navigate("/onboarding", { replace: true });
        setBootstrapped(true);
      }
    })();
     
  }, [user]);

  if (user === null || !bootstrapped) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground font-mono text-sm animate-pulse-soft">loading workspace…</div>
      </div>
    );
  }
  if (!cases || cases.length === 0) return null;

  return (
    <div className="h-screen w-screen flex bg-background text-foreground overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 overflow-y-auto scrollbar-thin px-6 lg:px-10 py-6 lg:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
